import QuitaList from './QuitaList'
export {QuitaList}
export default QuitaList
